import { Box, Checkbox, styled } from '@mui/material';
import { Card } from '@totalsoft/rocket-ui';
import { RoundedHeaderTableRow, SizedTableRow } from 'components/common/table/TableStyles';
import { withPropsExclusion } from 'utils/functions';

export const ItemsDetailsCard = styled(
  Card,
  withPropsExclusion('isSplit')
)(({ theme, isSplit }) => ({
  ...(isSplit && {
    '& .MuiCardContent-root': {
      paddingTop: 0,
      marginTop: theme.spacing(-2)
    }
  })
}));

export const ItemsTableContainer = styled(Box)(() => ({
  maxHeight: '60vh',
  overflowY: 'auto'
}));

export const ResidualValueGridTableRow = styled(
  SizedTableRow,
  withPropsExclusion('selectable')
)(({ selectable }) => ({
  cursor: selectable ? 'pointer' : 'auto'
}));

export const ResidualValueGridHeaderRow = styled(RoundedHeaderTableRow)(({ theme }) => ({
  '& th': {
    paddingBlock: theme.spacing(1)
  }
}));

export const SelectCheckbox = styled(Checkbox)(() => ({
  padding: 0,
  marginLeft: '9px',
  '&:hover': {
    backgroundColor: 'transparent'
  }
}));

export const SelectAllCheckbox = styled(SelectCheckbox)(({ theme }) => ({
  color: theme.palette.common.white,
  '&.Mui-checked': {
    color: theme.palette.common.white
  }
}));
